export const cart = {
  async get() {
    try {
      const response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error(error);
    }
  },

  async update(data: any) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      return await response.json();
    } catch (error) {
      console.error(error);
    }
  },

  async remove(id: string) {
    return this.update({ updates: { [id]: 0 } });
  },

  /**
   * Remove multiple items from cart in a single request
   * @param ids - Array of variant IDs to remove
   */
  async batchRemove(ids: string[]) {
    if (!ids.length) return;
    const updates = ids.reduce(
      (acc, id) => {
        acc[id] = 0;
        return acc;
      },
      {} as Record<string, number>,
    );
    return this.update({ updates });
  },
};
